import Vue from 'vue'
import Vuex from 'vuex'
import { extractVuexModule, createProxy } from 'vuex-class-component'
import GlobalStore from './global'

Vue.use(Vuex)

const store = new Vuex.Store({ modules: { ...extractVuexModule(GlobalStore) } })

export default store

export const Global = createProxy(store, GlobalStore)
